<template>

  <div>
    <div class="dash-heading"><i class="fa fa-sort-numeric-up" />&nbsp;Ways: <small>Overall Share Ratio: <b>{{this.formatNumber(stats.sharingRatio)}}%</b></small></div>

    <el-row :gutter="42">

      <el-col :span="24">
        <table class="el-table">
          <thead>
            <tr>
              <th>Sharing Ways</th>
              <th v-for="s in sharing">#{{s.ways}} way</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>

              <td>Sites #</td>
              <td  v-for="s in sharing" :key="">{{formatInteger(s.sites)}}</td>
              <td><b>{{formatInteger(this.sitesTotal)}}</b></td>
            </tr>

            <tr>
              <td>Sharers #</td>
              <td  v-for="s in sharing" :key="">{{s.sharers}}</td>
              <td><b>{{formatInteger(this.totalSharers)}}</b></td>
            </tr>
            <tr>
              <td>Percent</td>
              <td  v-for="s in sharing" :key="">{{formatNumber(s.percent, 1)}}%</td>
              <td><b>{{this.formatNumber(stats.sharingRatio)}}%</b></td>
            </tr>
          </tbody>
        </table>
      </el-col>

     <el-col :sm="24" :md="24" :lg="12">
        <div class="dash-heading">Sharers</div>
        <sharer-report />
      </el-col>

      <el-col :sm="23" :md="23" :lg="11" :offset="1">
        <div class="dash-heading">Sharer Ways</div>
        <sharer-ways-report  />
      </el-col>

      <el-col :sm="24" :md="24" :lg="24">
         <div class="dash-heading">Sites Ways</div>
         <sites-ways-table  />
       </el-col>


    </el-row>

  </div>
</template>


<script>

import PostMixins from '@/mixins/PostMixins'
import NumberMixins from '@/mixins/NumberMixins'

import SharerReport from '@/components/dashboard/sharers/SharerReport'
import SharerWaysReport from '@/components/dashboard/sharers/SharerWaysReport'
import SitesWaysTable from '@/components/dashboard/sharers/SitesWaysTable'

export default {
  mixins: [PostMixins, NumberMixins],

  components: {
    SharerReport,
    SharerWaysReport,
    SitesWaysTable
  },

  methods: {
    sharingData (data) {
      this.sharing = data
    }
  },

  computed: {
    sitesTotal: function () {
      return this.sum(this.sharing, 'sites')
    },

    totalSharers: function () {
      return this.sum(this.sharing, 'sharers')
    }
  },

  data () {
    return {
      sharing: [],
      stats: this.getStats()
    }
  },

  created () {
    this.fetchData('report/sharing' + (this.org().id ? '/org/' + this.org().id : ''), this.sharingData, 'Sharing Stats')
  }
}
</script>
